import type { FaireBrandEntity } from "../../entity_types/brand";

// The Woodsy Craft Co. — real Faire brand (b_atnn44mpxf). Identity metadata from
// ANALYTICS.CANONICAL.BRANDS; backs the ads-manager-2 "The Woodsy Craft Co."
// real-brand variant (advertiser -7828252857858171118).
export const b_atnn44mpxf: FaireBrandEntity = {
  token: "b_atnn44mpxf",
  type: "brand",
  name: "The Woodsy Craft Co.",
  description:
    "Screen-free DIY craft kits with everything included, made for family nights, classrooms, and gifting.",
  location: "The Dalles, OR, USA",
  isTopShop: true,
  tags: ["paper-novelty", "craft-kits", "kids-toys"],
  meta: {
    source: "snowflake",
    importedAt: "2026-08-20T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
